import axiosClient from 'api/config/axiosClient';

export const getExportLog = ({ pageNumber, pageSize, dateFrom, dateTo }) => {
  const url = `v1/logging?pageNumber=${pageNumber}&pageSize=${pageSize}&dateFrom=${dateFrom}&dateTo=${dateTo}`;
  return axiosClient.get(url, { timeout: 0 });
};

export const downloadExportLog = (payload) => {
  const url = `v1/logging/csv`;
  return axiosClient.post(url, payload, { timeout: 0 });
};
